import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShare as solidShare } from "@fortawesome/free-solid-svg-icons";
import { faHeart as solidHeart } from "@fortawesome/free-solid-svg-icons";
import { flipFlopChatLogo, logoFacebook, logoTelegram, logoTiktok, logoYoutube, profileVerified } from "assets";
import { requestSubmitFollowingUser, requestSubmitUnFollowinguUser } from "api-function/requestFriendStatusApi";
import NewsFeedIcon from "assets/icons/news-feed-icon";
import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";
import SearchParamsNotFound from "components/app/search-params-not-found/SearchParamsNotFound";
import { useCallback, useEffect, useRef, useState } from "react";
import { AppLog } from "services";
import { AppRecordStatusJK, RequestApi, RouteApi, RouteUrl, StatusMsg } from "utils";
import HelmetHtml from "components/app/helmet-html/HelmetHtml";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import UserProfileSkeleton from "./skeleton/UserProfileSkeleton";
import CoverUserProfile from "./components/CoverUserProfile";
import DailogEditPageProfile from "pages/setting-and-account/profile-detail/dailog-edit-profile-detail/DailogEditPageProfile";
import { AlignLeft, Contact, Info } from "lucide-react";
import QrCodeGenerater from "components/app/qr-code-generater/QrCodeGenerater";
import DailogEditUserProfile from "pages/setting-and-account/profile-detail/dailog-edit-profile-detail/DailogEditUserProfile";
import DialogShowUserFollowing from "./dialog/DialogShowUserFollowing";
import DialogShowUserPosts from "./dialog/DialogShowUserPosts";
import DialogShowUserLikes from "./dialog/DialogShowUserLikes";
import DialogPageSetting from "./dialog/DialogPageSetting";
import BtnFriendStatus from "components/app/btn-friend-status/BtnFriendStatus";
import AlertWellcome from "pages/auth/alert/AlertWellcome";
import { Service } from "utils/services";
import QrDevicesDetection from "components/app/qr-devices-detection/QrDevicesDetection";
import ProfileFeedContent from "./profile-contents/ProfileFeedContent";
import ProfileInfoContent from "./profile-contents/ProfileInfoContent";
import ProfileMediaContent from "./profile-contents/ProfileMediaContent";

import { setFriendUsers, setUser, setFollowerUsers, setFollowerLoading, setFollowingUsers, setFollowingLoading, setFriendLoading } from "store/profileSlice";

import { useDispatch } from "react-redux";
import { useAppSelector } from "store/store";
import { AppRecord, AppRecordStatus } from "models/appRecord";
import InfiniteScroll from "react-infinite-scroll-component";
import Masonry from "react-masonry-css";
import { Card } from "components/ui/card";
import SearchBar from "components/app/search-bar/SearchBar";
import { Skeleton } from "components/ui/skeleton";
import useProfileStore from "store/useProfile";
import UserCommunitiesSkeleton from "./skeleton/UserCommunitiesSkeleton";

export default function Profile() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const id: any = searchParams.get("id");
  const dynamicFlagParam = useRef<string>("");
  const navigate = useNavigate();
  const [isDialogUpdatePageStatus, setIsDialogUpdatePageStatus] = useState<boolean>(false);
  const [subLoadingTap, setSubLoadingTap] = useState<boolean>(false);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const flagFeedObserverRef = useRef<HTMLDivElement | null>(null);
  const flagPostObserverRef = useRef<HTMLDivElement | null>(null);
  const flagShareObserverRef = useRef<HTMLDivElement | null>(null);
  const flagLoveObserverRef = useRef<HTMLDivElement | null>(null);
  const flagLikeObserverRef = useRef<HTMLDivElement | null>(null);
  const [subLoading, setSubLoading] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");

  const breakpointColumnsObj = {
    default: 5,
    1536: 5,
    1280: 4,
    1024: 4,
    768: 3,
    425: 2,
  };

  // * ==== Variables ==== * //
  const { friendUsers, followerUsers, friendUserState, followerUserState, followingUsers, followingUserState } = useAppSelector((state) => state.profile);

  const {
    pageLoading,
    initializePage,
    feedPosts,
    posts,
    user,
    likes,
    shares,
    loves,
    profileSwtichFlagLoading,
    sharesRecord,
    likesRecord,
    lovesRecord,
    postsRecord,
    feedPostsRecord,
    userCoverPictures,
    fetchProfileViewPost,
  } = useProfileStore();

  const navLinkUserProfile = [
    {
      url: "feed",
      name: "Feed",
      icon: <NewsFeedIcon height="30" width="30" />,
    },
    {
      url: "posts",
      name: "Posts",
      icon: <AlignLeft size={30} />,
    },
    {
      url: "share",
      name: "Share",
      icon: <FontAwesomeIcon icon={solidShare} size="2x" />,
    },
    {
      url: "love",
      name: "Love",
      icon: <FontAwesomeIcon icon={solidHeart} size="2x" className="text-red-600" />,
    },
    {
      url: "like",
      name: "Like",
      icon: <FontAwesomeIcon icon={solidHeart} size="2x" className="text-blue-400" />,
    },
    {
      url: "community_friends",
      name: "Friends",
      icon: <Contact size={30} />,
    },
    {
      url: "info",
      name: "Info",
      icon: <Info size={30} />,
    },
  ];

  const communitiesNavlink = [
    {
      url: "community_friends",
      name: user?.user_type === "Personal" ? "Friends" : "Networking",
    },
    { url: "community_follower", name: "Follower" },
    { url: "community_following", name: "Following" },
  ];

  // * ==== Functions ==== * //
  const handleClickFetchApiNavLinkUserProfile = (id: string, link: string) => {
    dynamicFlagParam.current = link;

    navigate(`${RouteUrl.profile}?id=${id}&${link}`, {
      replace: true,
    });
  };

  const fetchSubTapContent = async ({ isRefresh = false }: { isRefresh?: boolean }) => {
    try {
      setSubLoadingTap(true);
      if (isRefresh) {
        setSubLoading(true);
      }

      let url: string = "";
      if (Service.isAuthenticated) {
        if (dynamicFlagParam.current === "community_friends") {
          // url = RouteApi.getFriendUser;
          url = Service.userAuth ? RouteApi.getFriendUser : "";
          url += `token=${Service.token}`;
        } else if (dynamicFlagParam.current === "community_follower") {
          url = RouteApi.getFollowerUser;
          url += `token=${Service.token}`;
        } else if (dynamicFlagParam.current === "community_following") {
          url = RouteApi.getFollowingUser;
          url += `token=${Service.token}`;
        }

        const data = {
          user_id: id,
          search_text: searchText,
        };

        await RequestApi(url, { data })
          .then((responses) => {
            if (responses.status === "success") {
              if (dynamicFlagParam.current === "community_friends") {
                const stateRecord: AppRecord = {
                  currentPage: 1,
                  currentIndex: 0,
                  nextPageUrl: responses["friend_users"]["next_page_url"] ?? "",
                  totalRecord: 0,
                  loadingStatus: responses["friend_users"]["next_page_url"] != null ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
                };
                dispatch(setFriendUsers(responses["friend_users"]));
                dispatch(setFriendLoading(stateRecord));
              } else if (dynamicFlagParam.current === "community_follower") {
                const stateRecord: AppRecord = {
                  currentPage: 1,
                  currentIndex: 0,
                  nextPageUrl: responses["follower_users"]["next_page_url"] ?? "",
                  totalRecord: 0,
                  loadingStatus: responses["follower_users"]["next_page_url"] != null ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
                };

                dispatch(setFollowerUsers(responses["follower_users"]));
                dispatch(setFollowerLoading(stateRecord));
              } else if (dynamicFlagParam.current === "community_following") {
                const stateRecord: AppRecord = {
                  currentPage: 1,
                  currentIndex: 0,
                  nextPageUrl: responses["following_users"]["next_page_url"] ?? "",
                  totalRecord: 0,
                  loadingStatus: responses["following_users"]["next_page_url"] != null ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
                };
                dispatch(setFollowingUsers(responses["following_users"]));
                dispatch(setFollowingLoading(stateRecord));
              }
            } else {
            }
            setSubLoading(false);
            setSubLoadingTap(false);
          })
          .catch((err) => {});
        setSubLoadingTap(false);
        setSubLoading(false);
      }
    } catch (error) {
      AppLog.show({
        message: `[fetchSubTapContent]`,
        status: StatusMsg.error,
        error,
      });
      setSubLoading(false);
      setSubLoadingTap(false);
    }
  };

  const fetchMoreCommunitiesSubTapContent = async ({ next }: { next: string }) => {
    if (dynamicFlagParam.current === "community_friends") {
      dispatch(
        setFollowerLoading({
          ...friendUserState,
          loadingStatus: AppRecordStatus.loadingMore,
        })
      );
    } else if (dynamicFlagParam.current === "community_follower") {
      dispatch(
        setFollowerLoading({
          ...followerUserState,
          loadingStatus: AppRecordStatus.loadingMore,
        })
      );
    } else if (dynamicFlagParam.current === "community_following") {
      dispatch(
        setFollowingLoading({
          ...followingUserState,
          loadingStatus: AppRecordStatus.loadingMore,
        })
      );
    }

    await RequestApi(next).then((responses) => {
      if (responses.status === "success") {
        if (dynamicFlagParam.current === "community_friends") {
          const stateRecord: AppRecord = {
            currentPage: 1,
            currentIndex: 0,
            nextPageUrl: responses["friend_users"]["next_page_url"] ?? "",
            totalRecord: 0,
            loadingStatus: responses["friend_users"]["next_page_url"] != null ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
          };

          const tmpPosts = [...friendUsers["data"], ...responses["friend_users"]["data"]];
          const newPost = { ...friendUsers, data: tmpPosts };
          dispatch(setFriendUsers(newPost));
          dispatch(setFriendLoading(stateRecord));
        } else if (dynamicFlagParam.current === "community_follower") {
          const stateRecord: AppRecord = {
            currentPage: 1,
            currentIndex: 0,
            nextPageUrl: responses["follower_users"]["next_page_url"] ?? "",
            totalRecord: 0,
            loadingStatus: responses["follower_users"]["next_page_url"] != null ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
          };

          const tmpPosts = [...followerUsers["data"], ...responses["follower_users"]["data"]];
          const newPost = { ...followerUsers, data: tmpPosts };
          dispatch(setFollowerUsers(newPost));
          dispatch(setFollowerLoading(stateRecord));
        } else if (dynamicFlagParam.current === "community_following") {
          const stateRecord: AppRecord = {
            currentPage: 1,
            currentIndex: 0,
            nextPageUrl: responses["following_users"]["next_page_url"] ?? "",
            totalRecord: 0,
            loadingStatus: responses["following_users"]["next_page_url"] !== null ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
          };

          const tmpPosts = [...followingUsers["data"], ...responses["following_users"]["data"]];
          const newPost = { ...followingUsers, data: tmpPosts };
          dispatch(setFollowingUsers(newPost));
          dispatch(setFollowingLoading(stateRecord));
        }
      }
    });
  };

  const requestFollowing = async ({ user, isArray }: { user: any; isArray: boolean }) => {
    const userId = user?.id;
    const result = await requestSubmitFollowingUser({ userId: userId });
    if (result.status === "success") {
      // if isArray = false It's btn on user Profile
      if (isArray === false) {
        let tmpUser = { ...user };

        tmpUser = result["user"];
        dispatch(setUser(tmpUser));
        useProfileStore.getState().updateUser(result["user"]);
      } else {
        if (dynamicFlagParam.current === "community_friends") {
          const tmpUserData = [...friendUsers["data"]];
          const findUser = tmpUserData.find((element) => element.id === result["user"]["id"]);
          if (findUser) {
            const updatedUserData = tmpUserData.map(
              (element) =>
                element.id === findUser.id
                  ? {
                      ...element,
                      friend_status: result["user"]["friend_status"],
                    } // Update the friend_status field
                  : element // Keep other users unchanged
            );
            dispatch(setFriendUsers({ ...friendUsers, data: updatedUserData }));
          }
        } else if (dynamicFlagParam.current === "community_follower") {
          const tmpUserData = [...followerUsers["data"]];
          const findUser = tmpUserData.find((element) => element.id === result["user"]["id"]);

          if (findUser) {
            const updatedUserData = tmpUserData.map(
              (element) =>
                element.id === findUser.id
                  ? {
                      ...element,
                      friend_status: result["user"]["friend_status"],
                    } // Update the friend_status field
                  : element // Keep other users unchanged
            );

            dispatch(setFollowerUsers({ ...friendUsers, data: updatedUserData }));
          }
        } else if (dynamicFlagParam.current === "community_following") {
          const tmpUserData = [...followingUsers["data"]];
          const findUser = tmpUserData.find((element) => element.id === result["user"]["id"]);

          if (findUser) {
            const updatedUserData = tmpUserData.map(
              (element) =>
                element.id === findUser.id
                  ? {
                      ...element,
                      friend_status: result["user"]["friend_status"],
                    } // Update the friend_status field
                  : element // Keep other users unchanged
            );

            dispatch(setFollowingUsers({ ...friendUsers, data: updatedUserData }));
          }
        }
      }
    }
  };

  const requestUnFollowing = async ({ user, isArray }: { user: any; isArray: boolean }) => {
    const userId = user?.id;
    const result = await requestSubmitUnFollowinguUser({ userId: userId });
    if (result.status === "success") {
      // if isArray = false It's btn on user Profile
      if (isArray === false) {
        let tmpUser = { ...user };
        tmpUser = result["user"];
        dispatch(setUser(tmpUser));

        useProfileStore.getState().updateUser(result["user"]);
      } else {
        if (dynamicFlagParam.current === "community_friends") {
          const tmpUserData = [...friendUsers["data"]];
          const findUser = tmpUserData.find((element) => element.id === result["user"]["id"]);

          if (findUser) {
            const updatedUserData = tmpUserData.map(
              (element) =>
                element.id === findUser.id
                  ? {
                      ...element,
                      friend_status: result["user"]["friend_status"],
                    } // Update the friend_status field
                  : element // Keep other users unchanged
            );

            dispatch(setFriendUsers({ ...friendUsers, data: updatedUserData }));
          }
        } else if (dynamicFlagParam.current === "community_follower") {
          const tmpUserData = [...followerUsers["data"]];
          const findUser = tmpUserData.find((element) => element.id === result["user"]["id"]);

          if (findUser) {
            const updatedUserData = tmpUserData.map(
              (element) =>
                element.id === findUser.id
                  ? {
                      ...element,
                      friend_status: result["user"]["friend_status"],
                    } // Update the friend_status field
                  : element // Keep other users unchanged
            );

            dispatch(setFollowerUsers({ ...friendUsers, data: updatedUserData }));
          }
        } else if (dynamicFlagParam.current === "community_following") {
          const tmpUserData = [...followingUsers["data"]];
          const findUser = tmpUserData.find((element) => element.id === result["user"]["id"]);

          if (findUser) {
            const updatedUserData = tmpUserData.map(
              (element) =>
                element.id === findUser.id
                  ? {
                      ...element,
                      friend_status: result["user"]["friend_status"],
                    } // Update the friend_status field
                  : element // Keep other users unchanged
            );

            dispatch(setFollowingUsers({ ...friendUsers, data: updatedUserData }));
          }
        }
      }
    }
  };

  const onClickFriend = ({ user, isArray }: { user: any; isArray: boolean }) => {
    if (user?.friend_status === "Friend" || user?.friend_status === "Following") {
      requestUnFollowing({ user, isArray });
    } else {
      requestFollowing({ user, isArray });
    }
  };

  const onTapCommunitiesNavLink = (link: string) => {
    dynamicFlagParam.current = link;

    if (dynamicFlagParam.current === "community_friends") {
      if (!friendUsers) {
        fetchSubTapContent({ isRefresh: false });
      }
    } else if (dynamicFlagParam.current === "community_follower") {
      if (!followerUsers) {
        fetchSubTapContent({ isRefresh: false });
      }
    } else if (dynamicFlagParam.current === "community_following") {
      if (!followingUsers) {
        fetchSubTapContent({ isRefresh: false });
      }
    }
    navigate(`${RouteUrl.profile}?id=${id}&${link}`, {
      replace: true,
    });
  };

  const navLinkCommunitiesContent = () => {
    if (dynamicFlagParam.current === "community_friends") {
      if (!friendUsers) return;
      return (
        <div className="p-1">
          {!subLoading && (
            <InfiniteScroll
              className={`relative`}
              dataLength={friendUsers["data"]?.length}
              next={() => fetchMoreCommunitiesSubTapContent({ next: friendUserState.nextPageUrl })}
              hasMore={friendUserState.nextPageUrl === "" ? false : true}
              loader={
                <div className="absolute bottom-2 left-0 w-full flex justify-center">
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 mb-8">
                    {[
                      ...Array(12).map((_: any, index: number) => {
                        return (
                          <div key={index}>
                            <UserCommunitiesSkeleton />
                          </div>
                        );
                      }),
                    ]}
                  </div>
                </div>
              }
              endMessage={
                <p className="absolute bottom-0 left-0 w-full text-center">
                  <b>Nothing more to load!</b>
                </p>
              }
            >
              {subLoadingTap && (
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
                  {[...Array(20)].map((_, i) => {
                    // return <Skeleton key={i} className="h-[400px] rounded-md" />;
                    return "";
                  })}
                </div>
              )}

              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 mb-8">
                {[...friendUsers?.data, ...(friendUserState.nextPageUrl ? [{}, {}, {}, {}, {}] : [])].map((user: any, index: number) => {
                  const lastIndex = friendUsers?.data.length;

                  if (index > lastIndex - 1 && friendUserState.nextPageUrl) {
                    return <UserCommunitiesSkeleton />;
                  } else {
                    return (
                      <Card key={index} className="rounded-md">
                        <div
                          className="cursor-pointer"
                          onClick={() => {
                            navigate(`/profile?id=${user?.id}&feed`);
                          }}
                        >
                          <ImageUrlProfile className="w-full object-cover h-[200px] rounded-t-md" user={user} />
                          {/* Name */}
                          <div className="p-2">
                            <div className="flex">
                              <h1 className="font-semibold text-lg line-clamp-1">{user?.name}</h1>
                              {user?.is_verified === "Yes" ? (
                                <>
                                  <div className="flex items-center justify-center pt-0.5 ml-1">
                                    <img src={profileVerified} style={{ width: 24, height: 24 }} alt="" />
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                            <p className={`line-clamp-1 ${user?.bio === "" ? "invisible" : ""}`}>{user?.bio !== "" ? user?.bio : "NoBio"}</p>
                          </div>
                        </div>

                        {/* Follower Post Like */}
                        <div className="grid grid-cols-3 text-center">
                          <div className="">
                            <h1 className="font-semibold">{user?.no_of_follower}</h1>
                            <p className="text-xs">Followers</p>
                          </div>
                          <div className="">
                            <h1 className="font-semibold">{user?.no_of_post}</h1>
                            <p className="text-xs">Posts</p>
                          </div>
                          <div className="">
                            <h1 className="font-semibold">{user?.no_of_like}</h1>
                            <p className="text-xs">Likes</p>
                          </div>
                        </div>

                        <div className="grid grid-cols-1 p-2">
                          <BtnFriendStatus
                            friendStatus={user?.friend_status}
                            onClick={() =>
                              onClickFriend({
                                user,
                                isArray: true,
                              })
                            }
                            userType={user?.user_type}
                          />
                        </div>
                      </Card>
                    );
                  }
                })}
              </div>
            </InfiniteScroll>
          )}
        </div>
      );
    } else if (dynamicFlagParam.current === "community_follower") {
      if (!followerUsers) return;
      return (
        <div className="p-1">
          {!subLoading && (
            <InfiniteScroll
              className={`relative`}
              dataLength={followerUsers["data"]?.length}
              next={() => fetchMoreCommunitiesSubTapContent({ next: followerUserState.nextPageUrl })}
              hasMore={followerUserState.nextPageUrl === "" ? false : true}
              loader={
                <div className="absolute bottom-2 left-0 w-full flex justify-center">
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 mb-8">
                    {[
                      ...Array(12).map((_: any, index: number) => {
                        return <UserCommunitiesSkeleton />;
                      }),
                    ]}
                  </div>
                </div>
              }
              endMessage={
                <p className="absolute bottom-0 left-0 w-full text-center">
                  <b>Nothing more to load!</b>
                </p>
              }
            >
              {subLoadingTap && (
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
                  {[...Array(20)].map((_, i) => {
                    return <Skeleton key={i} className="h-[400px]" />;
                  })}
                </div>
              )}
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 mb-8">
                {[...followerUsers?.data, ...(followerUserState.nextPageUrl ? [{}, {}, {}, {}, {}] : [])].map((user: any, index: number) => {
                  const lastIndex = followerUsers?.data.length;

                  if (index > lastIndex - 1 && followerUserState.nextPageUrl !== "") {
                    return <UserCommunitiesSkeleton />;
                  } else {
                    return (
                      <Card key={index} className="rounded-md">
                        <div
                          className="cursor-pointer"
                          onClick={() => {
                            navigate(`/profile?id=${user?.id}&feed`);
                          }}
                        >
                          <ImageUrlProfile className="w-full object-cover h-[200px] rounded-t-md" user={user} />
                          {/* Name */}
                          <div className="p-2">
                            <div className="flex">
                              <h1 className="font-semibold text-lg line-clamp-1">{user?.name}</h1>
                              {user?.is_verified === "Yes" ? (
                                <>
                                  <div className="flex items-center justify-center pt-0.5 ml-1">
                                    <img src={profileVerified} style={{ width: 24, height: 24 }} alt="" />
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                            <p className={`line-clamp-1 ${user?.bio === "" ? "invisible" : ""}`}>{user?.bio !== "" ? user?.bio : "NoBio"}</p>
                          </div>
                        </div>

                        {/* Follower Post Like */}
                        <div className="grid grid-cols-3 text-center">
                          <div className="">
                            <h1 className="font-semibold">{user?.no_of_follower}</h1>
                            <p className="text-xs">Followers</p>
                          </div>
                          <div className="">
                            <h1 className="font-semibold">{user?.no_of_post}</h1>
                            <p className="text-xs">Posts</p>
                          </div>
                          <div className="">
                            <h1 className="font-semibold">{user?.no_of_like}</h1>
                            <p className="text-xs">Likes</p>
                          </div>
                        </div>

                        <div className="grid grid-cols-1 p-2">
                          <BtnFriendStatus
                            friendStatus={user?.friend_status}
                            onClick={() =>
                              onClickFriend({
                                user,
                                isArray: true,
                              })
                            }
                            userType={user?.user_type}
                          />
                        </div>
                      </Card>
                    );
                  }
                })}
              </div>
            </InfiniteScroll>
          )}
        </div>
      );
    } else if (dynamicFlagParam.current === "community_following") {
      if (!followingUsers) return;
      return (
        <div className="p-1">
          {!subLoading && (
            <InfiniteScroll
              className={`relative`}
              dataLength={followingUsers["data"].length}
              next={() =>
                fetchMoreCommunitiesSubTapContent({
                  next: followingUserState?.nextPageUrl,
                })
              }
              hasMore={followingUserState.nextPageUrl === "" ? false : true}
              loader={<></>}
              endMessage={
                <p className="absolute bottom-0 left-0 w-full text-center">
                  <b>Nothing more to load!</b>
                </p>
              }
            >
              {subLoadingTap && (
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
                  {[...Array(20)].map((_, i) => {
                    return <Skeleton key={i} className="h-[400px]" />;
                  })}
                </div>
              )}
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 mb-8">
                {[...followingUsers?.data, ...(followingUserState.nextPageUrl ? [{}, {}, {}, {}, {}] : [])].map((user: any, index: number) => {
                  const lastIndex = followingUsers?.data.length;

                  if (index > lastIndex - 1 && followingUserState.nextPageUrl) {
                    return <UserCommunitiesSkeleton />;
                  } else {
                    return (
                      <Card key={index} className="rounded-md">
                        <div
                          className="cursor-pointer"
                          onClick={() => {
                            navigate(`/profile?id=${user?.id}&feed`);
                          }}
                        >
                          <ImageUrlProfile className="w-full object-cover h-[200px] rounded-t-md" user={user} />
                          {/* Name */}
                          <div className="p-2">
                            <div className="flex">
                              <h1 className="font-semibold text-lg line-clamp-1">{user?.name}</h1>
                              {user?.is_verified === "Yes" ? (
                                <>
                                  <div className="flex items-center justify-center pt-0.5 ml-1">
                                    <img src={profileVerified} style={{ width: 24, height: 24 }} alt="" />
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                            <p className={`line-clamp-1 ${user?.bio === "" ? "invisible" : ""}`}>{user?.bio !== "" ? user?.bio : "NoBio"}</p>
                          </div>
                        </div>

                        {/* Follower Post Like */}
                        <div className="grid grid-cols-3 text-center">
                          <div className="">
                            <h1 className="font-semibold">{user?.no_of_follower}</h1>
                            <p className="text-xs">Followers</p>
                          </div>
                          <div className="">
                            <h1 className="font-semibold">{user?.no_of_post}</h1>
                            <p className="text-xs">Posts</p>
                          </div>
                          <div className="">
                            <h1 className="font-semibold">{user?.no_of_like}</h1>
                            <p className="text-xs">Likes</p>
                          </div>
                        </div>

                        <div className="grid grid-cols-1 p-2">
                          <BtnFriendStatus
                            friendStatus={user?.friend_status}
                            onClick={() =>
                              onClickFriend({
                                user,
                                isArray: true,
                              })
                            }
                            userType={user?.user_type}
                          />
                        </div>
                      </Card>
                    );
                  }
                })}
              </div>
            </InfiniteScroll>
          )}
        </div>
      );
    }
  };

  // * ==== UseEffect ==== * //

  // Initialize page.
  useEffect(() => {
    const loadInitialPage = async () => {
      try {
        if (id) {
          await initializePage(id, dynamicFlagParam.current);
        }
      } catch (error) {
        AppLog.show({
          message: `[loadInitialPage]`,
          status: StatusMsg.error,
          error,
        });
      }
    };
    loadInitialPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // When flag changes: update flag-related content only
  useEffect(() => {
    if (dynamicFlagParam.current) {
      useProfileStore.getState().updateContentByFlag(dynamicFlagParam.current);
      if (Service.isAuthenticated) {
        if (dynamicFlagParam.current === "community_friends") {
          fetchSubTapContent({ isRefresh: false });
        }
      }
    }
  }, [dynamicFlagParam.current]);

  // init dynamic Flag
  for (const [key, value] of searchParams.entries()) {
    if (key !== "id") {
      // Exclude the 'id' key
      dynamicFlagParam.current = key;
    }
  }

  // Check if the URL already contains '&feed'
  useEffect(() => {
    if (!location.search.includes("feed")) {
      if (!dynamicFlagParam.current) {
        // Manually append '&feed' to the current URL
        const newUrl = `${location.pathname}${location.search}&feed`;
        navigate(newUrl, { replace: true }); // Update the URL without reloading the page
      }
    }
  }, [location, navigate]);

  useEffect(() => {
    if (["community_friends", "community_follower", "community_following"].includes(dynamicFlagParam.current)) {
      if (searchText === "") {
        fetchSubTapContent({ isRefresh: true });
      } else {
        fetchSubTapContent({ isRefresh: true });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  const loadMorePosts = async () => {
    if (dynamicFlagParam.current === "feed") {
      if (feedPostsRecord.canLoadMore() === false) return;
    } else if (dynamicFlagParam.current === "posts") {
      if (postsRecord.canLoadMore() === false) return;
    } else if (dynamicFlagParam.current === "share") {
      if (sharesRecord.canLoadMore() === false) return;
    } else if (dynamicFlagParam.current === "love") {
      if (lovesRecord.canLoadMore() === false) return;
    } else if (dynamicFlagParam.current === "like") {
      if (likesRecord.canLoadMore() === false) return;
    }

    setTimeout(async () => {
      fetchProfileViewPost(false);
    }, 500);
  };

  // Fetch Load More With Flag
  const handleIntersection = useCallback(
    (entries: IntersectionObserverEntry[]) => {
      if (!entries[0].isIntersecting) return;

      const canLoad =
        (dynamicFlagParam.current === "feed" && feedPostsRecord.loadingStatus === AppRecordStatusJK.loaded) ||
        (dynamicFlagParam.current === "posts" && postsRecord.loadingStatus === AppRecordStatusJK.loaded) ||
        (dynamicFlagParam.current === "share" && sharesRecord.loadingStatus === AppRecordStatusJK.loaded) ||
        (dynamicFlagParam.current === "love" && lovesRecord.loadingStatus === AppRecordStatusJK.loaded) ||
        (dynamicFlagParam.current === "like" && likesRecord.loadingStatus === AppRecordStatusJK.loaded);

      if (canLoad) loadMorePosts();
    },
    [dynamicFlagParam.current, feedPostsRecord.loadingStatus, postsRecord.loadingStatus, sharesRecord.loadingStatus, lovesRecord.loadingStatus, likesRecord.loadingStatus]
  );

  useEffect(() => {
    const observer = new IntersectionObserver(handleIntersection, { rootMargin: "1000px" });

    const currentRef =
      dynamicFlagParam.current === "feed"
        ? flagFeedObserverRef
        : dynamicFlagParam.current === "posts"
        ? flagPostObserverRef
        : dynamicFlagParam.current === "share"
        ? flagShareObserverRef
        : dynamicFlagParam.current === "love"
        ? flagLoveObserverRef
        : flagLikeObserverRef;

    if (currentRef.current) observer.observe(currentRef.current);

    return () => {
      observer.disconnect();
    };
  }, [dynamicFlagParam.current, handleIntersection]);

  // Display Profile Content
  const ProfileLinkContent = () => {
    if (dynamicFlagParam.current === "feed") {
      return (
        <div className="min-h-[1000px]">
          <ProfileFeedContent feeds={feedPosts} user={user} />
          <div ref={flagFeedObserverRef} />
        </div>
      );
    } else if (dynamicFlagParam.current === "posts") {
      return (
        <Masonry breakpointCols={breakpointColumnsObj} className="my-masonry-grid w-full mb-8 min-h-[1000px]" columnClassName="my-masonry-grid_column">
          {[...posts, {}, {}, {}, {}, {}].map((post: any, index: number) => {
            const lastIndex = posts.length;

            if (index > lastIndex - 1 && postsRecord.isLoadingMore()) {
              return (
                <>
                  <Skeleton id={`${post?.id}`} key={index} className="relative group mb-4 break-inside-avoid rounded-xl h-[400px]">
                    <div className="h-[100%] w-full rounded-t-xl relative">
                      <Skeleton className="h-5 w-[35px] bg-gray-200 dark:bg-gray-700 absolute top-2 left-2" />
                    </div>
                  </Skeleton>
                </>
              );
            } else {
              return (
                <div id={`${post?.id}`} key={index} className="relative group mb-4 break-inside-avoid bg-white rounded-xl">
                  <ProfileMediaContent post={post} />
                </div>
              );
            }
          })}
          <div ref={flagPostObserverRef} />
        </Masonry>
      );
    } else if (dynamicFlagParam.current === "share") {
      return (
        <Masonry breakpointCols={breakpointColumnsObj} className="my-masonry-grid w-full mb-8 min-h-[1000px]" columnClassName="my-masonry-grid_column">
          {[...shares, {}, {}, {}, {}, {}].map((post: any, index: number) => {
            const lastIndex = shares.length;

            if (index > lastIndex - 1 && sharesRecord.isLoadingMore()) {
              return (
                <>
                  <Skeleton id={`${post?.id}`} key={index} className="relative group mb-4 break-inside-avoid rounded-xl  h-[400px]">
                    <div className="h-[100%] w-full rounded-t-xl relative">
                      <Skeleton className="h-5 w-[35px] bg-gray-200 dark:bg-gray-700 absolute top-2 left-2" />
                    </div>
                  </Skeleton>
                </>
              );
            } else {
              return (
                <div id={`${post?.id}`} key={index} className="relative group mb-4 break-inside-avoid bg-white rounded-xl">
                  <ProfileMediaContent post={post} />
                </div>
              );
            }
          })}
          <div ref={flagShareObserverRef} />
        </Masonry>
      );
    } else if (dynamicFlagParam.current === "love") {
      return (
        <Masonry breakpointCols={breakpointColumnsObj} className="my-masonry-grid w-full mb-8 min-h-[1000px]" columnClassName="my-masonry-grid_column">
          {[...loves, {}, {}, {}, {}, {}].map((post: any, index: number) => {
            const lastIndex = loves.length;

            if (index > lastIndex - 1 && lovesRecord.isLoadingMore()) {
              return (
                <Skeleton id={`${post?.id}`} key={index} className="relative group mb-4 break-inside-avoid rounded-xl  h-[400px]">
                  <div className="h-[100%] w-full rounded-t-xl relative">
                    <Skeleton className="h-5 w-[35px] bg-gray-200 dark:bg-gray-700 absolute top-2 left-2" />
                  </div>
                </Skeleton>
              );
            } else {
              return (
                <div id={`${post?.id}`} key={index} className="relative group mb-4 break-inside-avoid bg-white rounded-xl">
                  <ProfileMediaContent post={post} />
                </div>
              );
            }
          })}
          <div ref={flagLoveObserverRef} />
        </Masonry>
      );
    } else if (dynamicFlagParam.current === "like") {
      return (
        <Masonry breakpointCols={breakpointColumnsObj} className="my-masonry-grid w-full mb-8 min-h-[1000px]" columnClassName="my-masonry-grid_column">
          {[...likes, {}, {}, {}, {}, {}].map((post: any, index: number) => {
            const lastIndex = likes.length;

            if (index > lastIndex - 1 && likesRecord.isLoadingMore()) {
              return (
                <>
                  <Skeleton id={`${post?.id}`} key={index} className="relative group mb-4 break-inside-avoid rounded-xl  h-[400px]">
                    <div className="h-[100%] w-full rounded-t-xl relative">
                      <Skeleton className="h-5 w-[35px] bg-gray-200 dark:bg-gray-700 absolute top-2 left-2" />
                    </div>
                  </Skeleton>
                </>
              );
            } else {
              return (
                <div id={`${post?.id}`} key={index} className="relative group mb-4 break-inside-avoid bg-white rounded-xl">
                  <ProfileMediaContent post={post} />
                </div>
              );
            }
          })}
          <div ref={flagLikeObserverRef} />
        </Masonry>
      );
    } else if (dynamicFlagParam.current === "community_friends" || dynamicFlagParam.current === "community_follower" || dynamicFlagParam.current === "community_following") {
      return (
        <>
          <Card className="p-4 space-y-2 mb-3 ">
            <div className="flex justify-between">
              <h1 className="font-bold text-lg font-san">Communities</h1>
              <SearchBar onValueChange={(value) => setSearchText(value)} />
            </div>
            {/* communitiesNavLink */}
            <div className="flex items-center">
              {communitiesNavlink.map((link: any, indexLink: number) => {
                return (
                  <button
                    key={indexLink}
                    onClick={() => {
                      dynamicFlagParam.current = link.url;
                      onTapCommunitiesNavLink(link.url);
                    }}
                    className={`px-4 py-2 hover:bg-slate-200 dark:hover:bg-background rounded-lg font-semibold
                      ${dynamicFlagParam.current === link.url ? "border-amber-400 text-amber-400 border-b-4" : ""}`}
                  >
                    {link.name}
                  </button>
                );
              })}
            </div>

            {/* Card communitiesNavLink */}
            <div className="min-h-[1000px]">{navLinkCommunitiesContent()}</div>
          </Card>
        </>
      );
    } else if (dynamicFlagParam.current === "info") {
      return <ProfileInfoContent user={user} />;
    }
  };

  return (
    <>
      <HelmetHtml title="FlipFlop Social Meida - Profile" description="" />
      <>
        {!id || id === "" ? (
          <>
            <SearchParamsNotFound params="profile id" />
          </>
        ) : pageLoading ? (
          <>
            <UserProfileSkeleton />
          </>
        ) : (
          <>
            <div className="flex flex-col justify-center w-full">
              <div className="border-b-4 border-gray-200">
                <div className="">
                  <CoverUserProfile userCoverPictures={userCoverPictures} />

                  {/* UserProfile */}
                  <div className="relative flex justify-center">
                    <div className="absolute -top-16 flex flex-col text-center">
                      <div className="relative">
                        <ImageUrlProfile isLinkProfile={false} user={user} isThumbnail={false} className="rounded-full w-[140px] h-[140px] border-4 bg-white" />
                      </div>
                    </div>
                  </div>
                </div>

                <div id="page-status" className="flex justify-center p-2">
                  <div className="flex justify-end w-[400px] sm:w-[1000px] md:w-[700px]">
                    {/* <div className="invisible" /> */}
                    <div className="flex items-center">
                      {user?.allow_setting === "Yes" && user?.user_type === "Page" ? (
                        <div className="space-x-2 flex items-center">
                          <DailogEditPageProfile />
                          <DialogPageSetting isDialogUpdatePageStatus={isDialogUpdatePageStatus} setIsDialogUpdatePageStatus={setIsDialogUpdatePageStatus} user={user} />
                        </div>
                      ) : (
                        <div className="isvisible h-9 w-9" />
                      )}

                      {user?.allow_edit === "Yes" && user?.user_type === "Personal" && (
                        <DailogEditUserProfile
                          userProfileDetail={user}
                          onValueChange={(value) => {
                            const updatedUser = { ...user, ...value };
                            useProfileStore.setState({ user: updatedUser });
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>

                {/* Profile Infomation */}
                <div className="px-4 space-y-3 mt-12">
                  <div>
                    {/* Name & Bio */}
                    <div className="text-center space-y-2 mb-3">
                      <div className=" flex justify-center">
                        <div className="flex items-center">
                          <p className="text-2xl font-bold line-clamp-1">{user?.name}</p>
                        </div>
                        {user?.is_verified === "Yes" ? (
                          <>
                            <div className="flex items-center justify-center pt-0.5 ml-1">
                              <img src={profileVerified} style={{ width: 24, height: 24 }} alt="" />
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>

                      <h1 className="font-semibold line-clamp-2 text-muted-foreground">{user?.bio}</h1>

                      {/* Socail Contact */}
                      {user?.user_type === "Page" && ["Unpublished", "Deleted"].includes(user?.status) ? (
                        <>
                          <button className="bg-destructive text-white p-2 rounded-md text-sm font-semibold">{user?.status}</button>
                        </>
                      ) : (
                        <>
                          <div className="flex justify-center">
                            <div className="flex justify-center items-center space-x-2">
                              {user?.facebook_link ? (
                                <Link to={`${user?.facebook_link}`}>
                                  <img className="w-[30px] h-[30px] border rounded-full cursor-pointer" src={logoFacebook} alt="facebook-logo" />
                                </Link>
                              ) : (
                                <></>
                              )}

                              {user?.telegram_link ? (
                                <Link to={`${user?.telegram_link}`}>
                                  <img className="w-[30px] h-[30px] border rounded-full cursor-pointer" src={logoTelegram} alt="telegram-logo" />
                                </Link>
                              ) : (
                                <></>
                              )}

                              {user?.tiktok_link ? (
                                <Link to={`${user?.tiktok_link}`}>
                                  <img className="w-[30px] h-[30px] border rounded-full cursor-pointer" src={logoTiktok} alt="tiktok-logo" />
                                </Link>
                              ) : (
                                <></>
                              )}

                              {user?.youtube_link ? (
                                <Link to={`${user?.youtube_link}`}>
                                  <img className="w-[30px] h-[30px] border rounded-full cursor-pointer" src={logoYoutube} alt="youtube-logo" />
                                </Link>
                              ) : (
                                <></>
                              )}

                              {user?.google_map_link ? (
                                <Link className="w-[30px] h-[30px] border rounded-full flex justify-center items-center" to={`${user?.google_map_link}`}>
                                  <i className="fa-solid fa-location-dot text-[#E3665C] fa-xl" />
                                </Link>
                              ) : (
                                <></>
                              )}

                              <div className="p-1 rounded-full bg-slate-100 dark:bg-background dark:hover:bg-slate-900">
                                <QrCodeGenerater linkUrl={`https://flipflop.maxx4business.com/@${user?.username}`} user={user} />
                              </div>

                              {user?.friend_status !== "Owner" ? (
                                <div className="flex justify-center items-center w-[30px] h-[30px] border rounded-full cursor-pointer bg-slate-100">
                                  <img className="w-5 h-5" src={flipFlopChatLogo} alt="youtube-logo" />
                                </div>
                              ) : (
                                <></>
                              )}
                              <div className="ms-3">
                                {user?.friend_status === "Owner" ? (
                                  <></>
                                ) : (
                                  <BtnFriendStatus
                                    className="h-[30px]"
                                    friendStatus={user?.friend_status}
                                    onClick={() => {
                                      if (Service.isAuthenticated) {
                                        onClickFriend({
                                          user,
                                          isArray: false,
                                        });
                                      } else {
                                        setShowAlert(true);
                                      }
                                    }}
                                    userType={user?.user_type}
                                  />
                                )}
                              </div>
                              {/* Friend User Avatar */}
                              <div className="flex justify-center -space-x-4 rtl:space-x-reverse ml-4">
                                {friendUsers?.data && Array.isArray(friendUsers.data) && friendUsers.data.length > 0 ? (
                                  friendUsers.data.map((friUser: any, indexFriUser: number) => (
                                    <ImageUrlProfile
                                      key={indexFriUser}
                                      isLinkProfile={true}
                                      user={friUser}
                                      className="w-8 h-8 border-2 border-white rounded-full dark:border-gray-800"
                                      alt=""
                                    />
                                  ))
                                ) : (
                                  <p className="text-gray-500"></p>
                                )}

                                {friendUsers?.last_page && friendUsers.last_page > 1 ? (
                                  <p className="flex items-center justify-center w-8 h-8 text-xs font-medium text-white bg-gray-700 border-2 border-white rounded-full hover:bg-gray-600 dark:border-gray-800">
                                    +{friendUsers.last_page * 3}
                                  </p>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  {/* Following & Followers & Posts & Likes */}
                  <div className="flex justify-center space-x-2 text-center font-bold text-md">
                    <div className="flex">
                      <p className="mr-1">{user?.no_of_follower}</p>
                      <p>Followers</p>
                    </div>
                    <p> • </p>
                    <DialogShowUserFollowing user={user} />
                    <p> • </p>
                    <DialogShowUserPosts user={user} />
                    <p> • </p>
                    <DialogShowUserLikes user={user} />
                  </div>

                  {/* NavLink UserProfile icons */}
                  <div className="text-center font-bold text-sm md:text-md">
                    <nav className="sticky top-[800px]">
                      <ul className="flex justify-center">
                        {navLinkUserProfile.map((link: any, indexLinkProfile: number) => {
                          return (
                            <div
                              onClick={() => handleClickFetchApiNavLinkUserProfile(id, link.url)}
                              className={` dark:bg-background dark:hover:bg-slate-900 rounded-sm px-4 py-3 ${
                                dynamicFlagParam.current === link.url ||
                                (link.url === "community_friends" && ["community_follower", "community_following", "community_friends"].includes(dynamicFlagParam.current))
                                  ? "border-amber-400 text-amber-400 border-b-4"
                                  : ""
                              } `}
                              key={indexLinkProfile}
                            >
                              <li>{link.icon}</li>
                            </div>
                          );
                        })}
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>

              {/* NavLink Content */}
              <div className=" dark:bg-background flex justify-center p-4 ">
                <div className="w-[1300px]">
                  {dynamicFlagParam.current === "community_friends" ||
                  dynamicFlagParam.current === "community_following" ||
                  dynamicFlagParam.current === "community_follower" ||
                  dynamicFlagParam.current === "info" ? (
                    <></>
                  ) : (
                    <>
                      {profileSwtichFlagLoading && (
                        <div className="grid grid-cols-2 xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
                          {[...Array(20)].map((_, i) => {
                            return <Skeleton key={i} className="h-[300px] rounded-xl" />;
                          })}
                        </div>
                      )}
                    </>
                  )}
                  {Service.isAuthenticated ? (
                    <>{ProfileLinkContent()}</>
                  ) : (
                    <div className="flex justify-center">
                      <div className="mt-2 w-[350px] sm:w-[450px] md:w-[550px] lg:w-[750px] text-center bg-white p-4 rounded-xl">
                        {user?.user_type === "Page" ? (
                          <>
                            <p className="">សូមទាញយកកម្មវិធីបណ្តាញសង្គម FlipFlop</p>
                            <p>ដើម្បីមើលមាតិការថ្មីៗពីគេហទំព័ររបស់យើងខ្ញុំ!</p>
                            <p className="mt-1">Download FlipFlop Social Media and follow us</p>
                            <p className="mt-1">to view our page's content!</p>
                          </>
                        ) : (
                          <>
                            <p className="">សូមទាញយកកមម្មវិធីបណ្តាញសង្គម FlipFlop</p>
                            <p>ដើម្បីទទួលមើលមាតិការថ្មីៗរបស់ខ្ញុំ!</p>
                            <p className="mt-1">Download FlipFlop Social Media and follow us</p>
                            <p className="mt-1">to view my content!</p>
                          </>
                        )}

                        <p className="mt-1 text-sm text-muted-foreground">Scan QR code below to download</p>

                        <QrDevicesDetection />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <AlertWellcome showAlert={showAlert} setShowAlert={setShowAlert} />
          </>
        )}
      </>
    </>
  );
}
